/* tslint:disable */
/* eslint-disable */
/**
 * Performo API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.29.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { CommentKindFromJSON, CommentKindToJSON, UserFromJSON, UserToJSON, } from './';
export function WorkorderCommentCommandFromJSON(json) {
    return WorkorderCommentCommandFromJSONTyped(json, false);
}
export function WorkorderCommentCommandFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'workorderId': !exists(json, 'workorderId') ? undefined : json['workorderId'],
        'user': !exists(json, 'user') ? undefined : UserFromJSON(json['user']),
        'commentText': !exists(json, 'commentText') ? undefined : json['commentText'],
        'commentTime': !exists(json, 'commentTime') ? undefined : (new Date(json['commentTime'])),
        'kind': !exists(json, 'kind') ? undefined : CommentKindFromJSON(json['kind']),
    };
}
export function WorkorderCommentCommandToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'workorderId': value.workorderId,
        'user': UserToJSON(value.user),
        'commentText': value.commentText,
        'commentTime': value.commentTime === undefined ? undefined : (value.commentTime.toISOString()),
        'kind': CommentKindToJSON(value.kind),
    };
}
